'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactUtils = require('react-utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var Pre = function Pre(props) {
  var className = props.className,
      use = props.use,
      rest = _objectWithoutProperties(props, ['className', 'use']);

  return _react2.default.createElement('pre', _extends({}, rest, {
    className: (0, _reactUtils.classNames)(className, {
      'private-pre--code': use === 'code'
    })
  }));
};

Pre.propTypes = {
  className: _react.PropTypes.string,
  use: _react.PropTypes.oneOf(['default', 'code'])
};

Pre.defaultProps = {
  use: 'default'
};

exports.default = Pre;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1179/js/elements/Pre.js
// module id = 346
// module chunks = 0